import React from 'react'

const About = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-center text-5xl text-sky-500 my-6 font-bold">
        ABOUT NHWM
      </h1>
      <div className="md:w-[80%] mx-auto">
        <p className="mt-4 text-xl text-justify text-[#274760]">
          NATIONAL HEALTHCARE AND WELLNESS MISSION is a collaboration of OPTIM
          HEALTH AND WELLNESS (OPC) PRIVATE LIMITED, a leading Organization for
          Healthcare & Wellness in India. We are educating & helping people to
          get prevented & reverse from Degenerative Lifestyle Diseases and
          educating people to maintain the Wellness by Free & Paid Healthcare &
          Wellness Services like Healthcare & Wellness Awareness & Education
          Service, Nutritional Healthcare & Wellness Assessment Services,
          Healthcare & Wellness Coaching & Training, Personalized Healthcare &
          Wellness Counselling, Workshops’ Registration and Recruiting
          Membership (Half-yearly, Yearly or Lifetime basis). NHWM is the only
          organization in PAN India engaging in Nutritional Assessment &
          Wellness Awareness Programmes since 2012 for all age groups along with
          expert guidance towards the prevention & reversal of all Degenerative
          Diseases like Diabetes, High BP, Heart Disease, Cancer, Arthritis,
          Obesity etc.
        </p>
      </div>
      <div className="w-full h-12"></div>
      <div>
        <div className="w-[80%] mx-auto">
          <h1 className="text-3xl text-center text-sky-500">Our Mission</h1>
          <p className="mt-4 text-3xl capitalize text-center text-[#274760]">
            Helping 10 Million people by 31st Dec' 2030 to get prevented or
            reverse from Diabetes & other Lifestyle Diseases.
          </p>
        </div>
        <div className="w-[80%] mx-auto mt-12">
          <h1 className="text-3xl text-center text-sky-500">Our Vission</h1>
          <p className="mt-4 text-3xl capitalize text-center text-[#274760]">
            Becoming a Pioneer Organization in India by Educating & Helping
            People How to Live a Healthy, Wealthy & Happy Life.
          </p>
        </div>
      </div>
      <div className="w-full h-12"></div>
      <div>
        <h1 className="text-center text-3xl text-sky-500">
          Message from Mission Director
        </h1>
        <div className="md:w-[80%] mx-auto">
          <p className="mt-4 text-xl text-justify text-[#274760]">
            We are honoured to inform you that, as part of our moral and social
            responsibility, we are committed to helping those around us stay
            healthy through our Educational Health Awareness Programme. This
            program includes proper health assessments (health check-ups) and
            personalized counselling. It is purely an educational initiative
            focused on nutritional health check-ups, where we educate people on
            how to prevent or reverse lifestyle diseases. <br /> <br />
            We have now launched a collaborative PAN India mission named the
            “National Healthcare & Wellness Mission”. As part of this mission,
            we have conducted a Basic Recruitment Test (BRT 2023-24) to recruit
            the right individuals to join us, but only a few have qualifies
            which is very less than our requirements. So, we are going to
            conduct another BRT in June 2025 and advertisement will be releases
            in March 2025. Our goal of this mission is to – “help & educate 10
            million people by December 31, 2030, to prevent or reverse lifestyle
            diseases”.
            <br /> <br />
            We invite all citizens of India to join our mission and provide
            valuable advice to help us move forward. Together, we can educate
            and support people to avoid potential health crises in the future.
            This is a moral and social responsibility for everyone in our
            society. We assure you that we will maintain positive relationships
            with all members of our Indian society. No one, inside or outside
            the mission, will be allowed to engage in any monetary scams or
            anti-social activities in the name of NHWM.
          </p>
          <p className="text-xl text-start text-[#274760] mt-2">
            Sincerely, <br />
            Dr. Monideep Boruah <br />
            Mission Director, NHWM
          </p>
        </div>
      </div>
      <div className="w-full h-16"></div>
    </div>
  );
}

export default About